import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { MdlDialogService, MdlDialogReference } from './mdl-dialog.service';
import { BooleanProperty } from './../common/boolean-property';
import { IMdlDialogConfiguration } from './mdl-dialog-configuration';




export class MdlDialogComponent {

   private template: TemplateRef<any>;

  // @deprecated use mdl-dialog-config instead (will be removed in 3.0.0)
   @BooleanProperty() public modal;
   public config: IMdlDialogConfiguration;
   public showEmitter: EventEmitter<MdlDialogReference> = new EventEmitter<MdlDialogReference>();
   public hideEmitter: EventEmitter<void> = new EventEmitter<void>();

  private isShown = false;
  private dialogRef : MdlDialogReference = null;

  constructor(private dialogService: MdlDialogService) {}


  public show(): Observable<MdlDialogReference> {

    if(this.isShown){
      throw new Error('Only one instance of an embedded mdl-dialog can exist!');
    }
    this.isShown = true;

    let mergedConfig: IMdlDialogConfiguration = this.config || {};

    // mdl-modal overwrites config.isModal if present
    mergedConfig.isModal = typeof this.modal !== 'undefined' ? this.modal : mergedConfig.isModal;
    // default is true
    if (typeof mergedConfig.isModal === 'undefined'){
      mergedConfig.isModal = true;
    }

    let result: Subject<any> = new Subject();

    let p = this.dialogService.showDialogTemplate(this.template, mergedConfig);
    p.subscribe( (dialogRef: MdlDialogReference) => {

      this.dialogRef = dialogRef;

      this.dialogRef.onVisible().subscribe( () => {
        this.showEmitter.emit(dialogRef);

        result.next(dialogRef);
        result.complete();

      });

      this.dialogRef.onHide().subscribe( () => {
        this.hideEmitter.emit(null);
        this.dialogRef = null;
        this.isShown = false;
      });

    })
    return result.asObservable();
  }

  public close() {
    if (this.dialogRef){
      this.dialogRef.hide();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-dialog',
  template: `
    <div *dialogTemplate>
      <ng-content></ng-content>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlDialogService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'template': [{ type: ViewChild, args: [TemplateRef, ] },],
'modal': [{ type: Input, args: ['mdl-modal', ] },],
'config': [{ type: Input, args: ['mdl-dialog-config', ] },],
'showEmitter': [{ type: Output, args: ['show', ] },],
'hideEmitter': [{ type: Output, args: ['hide', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
